import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from './locales';

export const routing = defineRouting({
    // A list of all locales that are supported
    locales: SUPPORTED_LOCALES,

    // Used when no locale matches
    defaultLocale: DEFAULT_LOCALE,

    // `as-needed` 在本地开发环境会导致默认语言路径出现自我重定向。
    // 线上继续保留无前缀英文 URL，本地开发改为显式前缀，避免 `/` 和 `/pricing` 循环跳转。
    localePrefix: process.env.NODE_ENV === 'production' ? 'as-needed' : 'always'
});

// Lightweight wrappers around Next.js' navigation APIs
export const { Link, redirect, usePathname, useRouter } =
    createNavigation(routing);
